/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Report_Image_Type_Not_AllowedInputs */

const es_co2_error_report_image_type_not_allowed = /** @type {(inputs: Error_Report_Image_Type_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato de imagen no permitido. Usa JPG, PNG, WEBP o SVG.`)
};

/**

* @param {Error_Report_Image_Type_Not_AllowedInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_report_image_type_not_allowed = /** @type {((inputs?: Error_Report_Image_Type_Not_AllowedInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Report_Image_Type_Not_AllowedInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_report_image_type_not_allowed(inputs)
});